import * as S from "./styles";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import {Card, Container, Text1, Title1, Title3} from "../../../styles/components";
import {Button} from "../../Button";

import PhoneImage from '../../../assets/images/m_cnt5_phone.png';

export const Content5 = () => {
    return (
        <Container>
            <Card>
                <S.Body>
                    <Title1><FormattedMessage id="personalTitle"/></Title1>
                    <Text1><FormattedMessage id="personalText1"/></Text1>
                    <S.Content>
                        <S.Block>
                            <S.BlockText>
                                <Title3><FormattedMessage id="personalSubTitle1"/></Title3>
                                <Text1><FormattedMessage id="personalSubText1"/></Text1>
                                <Title3><FormattedMessage id="personalSubTitle2"/></Title3>
                                <Text1><FormattedMessage id="personalSubText2"/></Text1>
                                <Text1><FormattedMessage id="personalSubText3"/></Text1>
                            </S.BlockText>
                            <S.BlockPhone>
                                <S.PhoneImage src={PhoneImage}/>
                            </S.BlockPhone>
                        </S.Block>
                    </S.Content>
                    <S.MobileContent>
                        <S.BlockPhone>
                            <S.PhoneImage src={PhoneImage}/>
                        </S.BlockPhone>
                        <S.BlockText>
                            <Title3><FormattedMessage id="personalSubTitle1"/></Title3>
                            <Text1><FormattedMessage id="personalSubText1"/></Text1>
                            <Title3><FormattedMessage id="personalSubTitle2"/></Title3>
                            <Text1><FormattedMessage id="personalSubText2"/></Text1>
                            <Text1><FormattedMessage id="personalSubText3"/></Text1>
                        </S.BlockText>
                    </S.MobileContent>
                    <Link to='/'><Button><FormattedMessage id="personalButton1"/></Button></Link>
                </S.Body>
            </Card>
        </Container>
    );
}